module.exports = __webpack_public_path__ + "media/headLeft2.75a118e4.mp4";